import { ViError } from '@vi-iot/client';
import {
  AssistantConcepts,
  AssistantDocumentDetails,
  AssistantFeedback,
  AssistantSearch,
} from '@vi-iot/client/apis/assistant/assistant.api-model';
import { StatusLoadedValue } from '../app.state.models';

export interface AssistantFilterSection {
  label?: string;
  items: AssistantFilterParent[];
}

export interface AssistantFilterItem {
  name: string;
  value?: {
    attribute?: string;
    concept?: AssistantConcepts;
  };
}

export interface AssistantFilterParent extends AssistantFilterItem {
  children?: AssistantFilterItem[];
  isStandAloneParent?: boolean;
}

export interface AssistantChipFilter extends AssistantFilterItem {
  sectionLabel: string;
}

export interface AssistantDocumentsState extends StatusLoadedValue<AssistantSearch[]> {
  totalCount: number;
  canFetch: boolean;
}

export interface SelectedDocumentsState {
  searchDocument: AssistantSearch;
  details: StatusLoadedValue<AssistantDocumentDetails>;
  content: StatusLoadedValue<string>;
  images: StatusLoadedValue<AssistantImages[]>;
}

export interface AssistantFeedbackState {
  filters: AssistantFeedbackFiltersState;
  feedbackData: AssistantFeedbackData;
}

export interface AssistantFeedbackData extends StatusLoadedValue<AssistantFeedback[]> {
  totalCount: number;
  canFetch: boolean;
}

export interface AssistantOverlayState {
  current: AssistantOverlayTypeEnum;
  previous: AssistantOverlayTypeEnum;
}

export interface AssistantImages {
  name: string;
  blob: Blob;
  error?: ViError;
}

export interface AssistantFeedbackFiltersState {
  search: string;
  filter: AssistantFeedbackPredefinedRanges;
  startDate: string;
  endDate: string;
  sortBy: AssistantFeedbackSortOrder;
}

export enum AssistantOverlayTypeEnum {
  SearchView,
  FeedbacksView,
  DocumentDetailsView,
}

export enum AssistantSupportedLanguages {
  da = 'da',
  de = 'de',
  en = 'en',
  es = 'es',
  fi = 'fi',
  fr = 'fr',
  it = 'it',
  ja = 'ja',
  ko = 'ko',
  nl = 'nl',
  no = 'no',
  pt = 'pt',
  ru = 'ru',
  sv = 'sv',
  zh = 'zh',
}

export const assistantSupportedLanguagesList: string[] = [
  AssistantSupportedLanguages.da,
  AssistantSupportedLanguages.de,
  AssistantSupportedLanguages.en,
  AssistantSupportedLanguages.es,
  AssistantSupportedLanguages.fi,
  AssistantSupportedLanguages.fr,
  AssistantSupportedLanguages.it,
  AssistantSupportedLanguages.ja,
  AssistantSupportedLanguages.ko,
  AssistantSupportedLanguages.nl,
  AssistantSupportedLanguages.no,
  AssistantSupportedLanguages.pt,
  AssistantSupportedLanguages.ru,
  AssistantSupportedLanguages.sv,
  AssistantSupportedLanguages.zh,
];

export enum AssistantDocumentType {
  html = 'Html',
  pdf = 'Pdf',
  decisionTree = 'Tree',
}

export enum AssistantFeedbackPredefinedRanges {
  Today = 'today',
  Last7Days = 'last7days',
  Last30Days = 'last30days',
  LastYear = 'lastYear',
  Custom = 'custom',
}

export enum AssistantFeedbackSortOrder {
  None = 'none',
  Positive = 'desc',
  Negative = 'asc',
}

export interface AssistantFilterPayload {
  [key: string]: string[];
}

export const ASSISTANT_DOCUMENT_LIMIT = 9;

export const ASSISTANT_URL_DOCUMENT_ID = 'documentId';

export const ASSISTANT_VIASSIST_SEARCH_QUERY_PARAM = 'viassist_search';

export const ASSISTANT_IS_SET_DEFAULT_LANGUAGE_FILTER = 'isSetDefaultLanguageFilter';

export enum AppServiceType {
  ViGuide = 'ViGuide',
  ViGuideServiceticket = 'ViGuideServiceticket',
}
